export const LOGIN = 'LOGIN'
export const LOGIN_GOOGLE = 'LOGIN_GOOGLE'
export const LOGOUT = 'LOGOUT'
export const CHECK_AUTH = 'CHECK_AUTH'
export const RECOVERY_PASS = 'RECOVERY_PASS'
export const FECTH_AUTH = 'FECTH_AUTH'

export const FECTH_SIDEBAR = 'FECTH_SIDEBAR'
export const FECTH_SHOW_SIDEBAR = 'FECTH_SHOW_SIDEBAR'


// WEBPACK FOOTER //
// ./src/store/actions.type.js